import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { FileDown, Loader2 } from "lucide-react";

const SHORT = { loe: "LoE", msa: "MSA & SOW" };

export async function downloadSignedPdf(onboardingId, key) {
  const r = await api.get(`/onboarding/${onboardingId}/signed/${key}/pdf`, { responseType: "blob" });
  const cd = r.headers["content-disposition"] || "";
  const name = (cd.match(/filename="([^"]+)"/) || [])[1] || `${key}_signed.pdf`;
  const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Staff-side "download signed PDF" chip for one document of an onboarding.
export function SignedPdfButton({ onboardingId, docKey, label }) {
  const [busy, setBusy] = useState(false);
  async function go(e) {
    e.stopPropagation();
    setBusy(true);
    try { await downloadSignedPdf(onboardingId, docKey); }
    catch (err) { toast.error("Could not generate the signed PDF"); }
    finally { setBusy(false); }
  }
  return (
    <button
      type="button"
      data-testid={`signed-pdf-${docKey}-${onboardingId}`}
      onClick={go}
      disabled={busy}
      title="Download signed copy (PDF)"
      className="inline-flex items-center gap-1 text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded border border-[var(--navy)] text-[var(--navy)] hover:bg-[var(--navy)]/5 transition"
    >
      {busy ? <Loader2 size={9} className="animate-spin" /> : <FileDown size={9} />} {label || SHORT[docKey]} PDF
    </button>
  );
}

export function signedKeys(o) {
  if (o.signed_docs?.length) return o.signed_docs;
  return o.status === "signed" ? ["loe"] : [];
}
